import React, { useState } from "react";
import ReactApexChart from "react-apexcharts";

export default function PieChartsDasboard() {
  const [chartData, setChartData] = useState({
    series: [30, 40, 30],
    options: {
      chart: {
        type: "pie",
      },
      labels: ["Pass", "Fail", "Dropout"],
      colors: ["#67B6DB", "#A267DB", "#6771DB"],
      legend: {
        show: true, // Ensures the legend is visible
        position: "bottom", // Moves the legend to the bottom
        horizontalAlign: "center", // Centers the legend
      },
      responsive: [
        {
          breakpoint: 768, // Tablet & mobile screens
          options: {
            chart: {
              width: 300, // Reduce chart size
              height: 300,
            },
            legend: {
              position: "bottom",
            },
          },
        },
        {
          breakpoint: 480, // Small mobile screens
          options: {
            chart: {
              width: 200, // Further reduce for small screens
              height: 200,
            },
            legend: {
              position: "bottom",
            },
          },
        },
      ],
    },
  });
  return (
    <div>
      <div id="chart">
        <ReactApexChart
          options={chartData.options}
          series={chartData.series}
          type="pie"
          width={380}
        />
      </div>
    </div>
  );
}
